import React from 'react';

import Providers from './components/Providers';
import Layout from './layouts/Layout';

const App = () => {
    return (
        <Providers>
            <Layout />
        </Providers>
    );
};

export default App;
